module.exports = __webpack_public_path__ + "img/a.6a7e8f9b.png";